/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_No_OtherInputs */

const en_pwf_no_other = /** @type {(inputs: Pwf_No_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no other workflow to switch to. Create one in Administration first.`)
};

const de_pwf_no_other = /** @type {(inputs: Pwf_No_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt keinen anderen Workflow zum Wechseln. Lege zuerst in der Administration einen an.`)
};

/**
* | output |
* | --- |
* | "There is no other workflow to switch to. Create one in Administration first." |
*
* @param {Pwf_No_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_no_other = /** @type {((inputs?: Pwf_No_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_No_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_no_other(inputs)
	return en_pwf_no_other(inputs)
});